<template>
  <div class="introduction-trigger">
    <div v-for="(cardContent, i) in cardContents" :key="i" class="trigger-card-wrapper">
      <TriggerCard class="trigger-card">
        <template v-slot:card-text>{{ cardContent.cardText }}</template>
        <template v-slot:circle-text>{{ cardContent.circleText }}</template>
      </TriggerCard>
    </div>
  </div>
</template>

<script>
import TriggerCard from '@/components/LP/molecules/TriggerCard'

export default {
  props: {
    company: {
      type: String,
    },
  },
  data () {
    // 定数名はパス名（社名）と一致させること
    const kinoshitanokaigo = [
      {
        "cardText": "採用活動の効率化、日程調整の自動化",
        "circleText": "導入の目的"
      },
      {
        "cardText": "採用活動における日程調整部分に苦慮。面接仮枠を用意していたが、調整業務を行っている最中に予定が埋まり、重複してしまう事も。",
        "circleText": "課題"
      },
      {
        "cardText": "安価なプラットフォームと日程調整の自動化",
        "circleText": "導入の決め手"
      },
      {
        "cardText": "面接日程調整業務の自動化による工数の大幅削減に成功",
        "circleText": "効果"
      },
    ]
    const medicalcareservice = [
      {
        "cardText": "外国人採用における応募の一次受付対応として",
        "circleText": "導入の目的"
      },
      {
        "cardText": "多数寄せられる外国人の方からのお問い合わせへの対応に時間を費やしてしまい、負担となっていた",
        "circleText": "課題"
      },
      {
        "cardText": "各機能のブラッシュアップが多く、期待度が高かった点",
        "circleText": "導入の決め手"
      },
      {
        "cardText": "外国人採用の足掛かりをHRモンスターを受け皿にすることで発展",
        "circleText": "効果"
      },
    ]
    return {
      // パスを変数名化
      cardContents: eval(this.company)
    }
  },
	components: {
    TriggerCard,
	}
}
</script>

<style scoped lang="scss">
.introduction-trigger {
  background-color: #f5e6fe;
  padding: 80px 40px;
  .trigger-card-wrapper {
    display: flex;
    justify-content: center;
    margin-left: 80px;
  }
  .trigger-card-wrapper:not(:first-child) {
    margin-top: 40px;
  }
}

@media screen and (max-width: 896px) {
  .introduction-trigger {
    padding: 40px;
  }
}

@media screen and (max-width: 480px) {
  .introduction-trigger {
    padding: 40px 16px;
  }
  .introduction-trigger {
    .trigger-card-wrapper {
      margin-left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/organisms/IntroductionTrigger.vue